<template>
	<div>
		<!--<v-alert
      prominent
      text
      type="info"
    >
      {{ $t("problemNotification") }}
    </v-alert>-->
  	<Kings/>
		<v-spacer></v-spacer>
		<template v-if="!isLoading" > <!-- got scamas -->
			<v-row no-gutters>
	      <v-col
	        v-for="scama in scamas"
	        :key="scama.id"
	        style="margin:4px 10px; !important" 
	      >
	        <ScamaCard 
		        :title="scama.name"
		        :photo="scama.photo"
		        :en="scama.url_en" 
		        :fr="scama.url_fr" 
		        :ar="scama.url_ar" 
		        :il="scama.url_il"
		    	/>
	      </v-col>
	    </v-row>

	  	<v-pagination
	      v-model="pagination.current"
	      :length="pagination.total"
	      @input="updateVisibleScamas"
	    ></v-pagination>
		</template>
  	<template v-else>	<!-- Loading ... -->
  		<v-row no-gutters>
    		<v-col
	        v-for="index in 8"
	        :key="index"
	        style="margin:4px 10px; !important" 
	      >
					<v-skeleton-loader
			      class="mx-auto"
			      min-width="296"
			      max-width="296"
			      type="list-item-avatar-three-line"
			    ></v-skeleton-loader>
		    </v-col>
	  	</v-row>
		</template >
  </div>
</template>

<script>
import Scama from "@/apis/Scama";
import ScamaCard from "@/components/scamas/card";
import Kings from "@/components/scamas/kings";

import { mapGetters,mapActions } from 'vuex';

export default {
  name: 'Dashboard',

  components: {
    ScamaCard,
    Kings
  },

  data(){
  	return {
  		isLoading: true,
  		scamas: null,
  		pagination: {
        current: 1,
        total: 6,
        pageSize : 8
	    }
  	}
  },

  computed: {
  	...mapGetters({
      allScamas : 'scamas/allScamas',
    }),
  },


  methods: {
  	...mapActions({
      fetchScamas: 'scamas/fetchScamas',
    }),

  	//Get all scamas and update pagination
  	async getAllScamas(){
  		await this.fetchScamas();
  		this.updateVisibleScamas();
  		this.isLoading = false;
  	},

  	//Update pagination
  	updateVisibleScamas() {
      this.scamas = this.allScamas.slice(
      	(this.pagination.current - 1) * this.pagination.pageSize, 
      	((this.pagination.current - 1) * this.pagination.pageSize) + this.pagination.pageSize
      );
    }
  },

  created(){
  	if(this.allScamas.length == 0){
  		this.getAllScamas();
  	}

  	else{
  		this.updateVisibleScamas();
  		this.isLoading = false;
  	}
  }
};
</script>
